import { t } from "@lingui/macro";
import { useAtom } from "jotai";
import { range } from "lodash";

import { DropdownSelect } from "@whoosh/design-system/src/components/controls/DropdownSelect";
import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

import { selectedPartySize_atom } from "../../../../BookingDetail/ForYouDiningRemains/atoms";

type Props = {
  selectedGroupSize?: number;
  onChange?: (groupSize: number) => void;
};

export const DiningGroupSizeSelector = ({
  selectedGroupSize: controlledGroupSize,
  onChange,
}: Props) => {
  const [selectedGroupSize, setSelectedGroupSize] = useAtom(
    selectedPartySize_atom
  );
  const groupSize = controlledGroupSize ?? selectedGroupSize;

  const groupSizeOptions = range(1, 13, 1).map((o) => ({
    label: `${o}`,
    value: `${o}`,
  }));

  const handleGroupSizeChange = (groupSize: string) => {
    const nextGroupSize = Number(groupSize);
    onChange?.(nextGroupSize);

    if (!onChange) {
      setSelectedGroupSize(nextGroupSize);
    }
  };

  return (
    <VStack gap={4}>
      <Text
        maxFontSizeMultiplier={2}
        variant="mainSmallSemiBold"
      >{t`Group Size`}</Text>
      <DropdownSelect
        options={groupSizeOptions}
        onChange={(val) => {
          if (val) handleGroupSizeChange(val);
        }}
        value={groupSize.toString()}
      />
    </VStack>
  );
};
